export { renderAlphaSlider_unstable as renderAlphaSlider } from '@fluentui/react-color-picker';
